import { Component, Input } from '@angular/core';

@Component({
  selector: 'monorepo-emb-success',
  templateUrl: './emb-success.component.html',
  styleUrls: ['./emb-success.component.scss'],
})
export class EmbSuccessComponent {
  @Input() message: string = '';
  constructor() {}
}
